// Google Analytics utility functions
const GA_TRACKING_ID = process.env.REACT_APP_GA_TRACKING_ID || 'G-NZZPN019YH';

// Initialize Google Analytics
export const initGA = () => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('config', GA_TRACKING_ID, {
      page_title: document.title,
      page_location: window.location.href,
    });
  }
};

// Track page views
export const trackPageView = (url, title) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('config', GA_TRACKING_ID, {
      page_title: title,
      page_location: url,
    });
  }
};

// Track events
export const trackEvent = (action, category = 'General', label = '', value = 0) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', action, {
      event_category: category,
      event_label: label,
      value: value,
    });
  }
};

// Enhanced Ecommerce - Track Purchase
export const trackPurchase = (transactionId, value, currency = 'USD', items = []) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'purchase', {
      transaction_id: transactionId,
      value: value,
      currency: currency,
      items: items.map(item => ({
        item_id: item.id || item.sku,
        item_name: item.name,
        category: item.category || 'Custom Prints',
        quantity: item.quantity,
        price: item.price,
      })),
    });
  }
};

// Enhanced Ecommerce - Track Add to Cart
export const trackAddToCart = (currency = 'USD', value, items = []) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'add_to_cart', {
      currency: currency,
      value: value,
      items: items.map(item => ({
        item_id: item.id || item.sku,
        item_name: item.name,
        category: item.category || 'Custom Prints',
        quantity: item.quantity,
        price: item.price,
      })),
    });
  }
};

// Enhanced Ecommerce - Track Begin Checkout
export const trackBeginCheckout = (currency = 'USD', value, items = []) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'begin_checkout', {
      currency: currency,
      value: value,
      items: items.map(item => ({
        item_id: item.id || item.sku,
        item_name: item.name,
        category: item.category || 'Custom Prints',
        quantity: item.quantity,
        price: item.price,
      })),
    });
  }
};

// Track file uploads
export const trackFileUpload = (fileName, fileSize) => {
  trackEvent('file_upload', 'Engagement', fileName, fileSize);
};

// Track price calculator usage
export const trackPriceCalculation = (quantity, totalPrice) => {
  trackEvent('price_calculation', 'Engagement', `${quantity} prints`, totalPrice);
};

export default {
  initGA,
  trackPageView,
  trackEvent,
  trackPurchase,
  trackAddToCart,
  trackBeginCheckout,
  trackFileUpload,
  trackPriceCalculation,
}; 